import React from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { ArrowForward as ArrowIcon } from '@mui/icons-material';
import about from '../assets/images/aboutus_01.webp';
function About() {
  return (
    <Box
      sx={{
        pt: { xs: 2, md: 12 },
        px: { xs: 2, md: 4 },
        pb: { xs: 8, md: 12 },
        bgcolor: 'white', // 白色背景
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, px: { xs: 0, md: 4 } }}>
        <Grid container spacing={ { xs: 4, md: 8 }} alignItems="center">

          {/* 左侧图片区域 */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                position: 'relative',
                height: { xs: '400px', md: '500px' },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src={about} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="About" />

            </Box>
          </Grid>
          
          {/* 左侧文字内容 */}
          <Grid item xs={12} md={7}>
            <Box sx={{ pl: { md: 3 } }}>
              {/* 小标题 */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 0, md: 3 } }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: '#9f2122', // 点睛色
                    fontWeight: 600,
                    fontSize: '1rem',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase'
                  }}
                >
                  About Us
                </Typography>
                <ArrowIcon sx={{ color: '#9f2122', ml: 1, fontSize: '1.2rem' }} />
              </Box>

              {/* 主标题 */}
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontFamily: 'serif',
                  fontWeight: 700,
                  color: '#07284b', // 主题色
                  mb: { xs: 2, md: 4 },
                  fontSize: { xs: '2.5rem', md: '3.25rem' },
                  lineHeight: 1.2
                }}
              >
                CHIHUI MANDARIN HUB
              </Typography>

              {/* 描述文字 */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#34495e',
                    fontSize: '1.25rem',
                    lineHeight: 1.8,
                    mb: { xs: 1, md: 3 }
                  }}
                >
                  CHIHUI Mandarin Hub is a premier language school in Singapore, offering systematic online and in-person Chinese courses for global learners. 
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#34495e',
                    fontSize: '1.25rem',
                    lineHeight: 1.8,
                    mb: { xs: 1, md: 3 }
                  }}
                >
                  Driven by our mission — <b>“ Master Chinese, Connect with the World ”</b> — we design programs that reflect global market needs and diverse cultural contexts, fully aligned with international language assessment standards. 
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#34495e',
                    fontSize: '1.25rem',
                    lineHeight: 1.8
                  }}
                >
                  We empower students to efficiently master practical Chinese, explore Chinese culture, and enhance their language proficiency, exam skills, and cross-cultural interactions.
                </Typography>
              </Box>

              {/* 行动按钮 */}
              <Button
                variant="contained"
                endIcon={<ArrowIcon />}
                href="/aboutus"
                sx={{
                  bgcolor: '#9f2122', // 点睛色
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  fontSize: '1rem',
                  fontWeight: 600,
                  borderRadius: '25px',
                  textTransform: 'none',
                  boxShadow: '0 4px 15px rgba(159, 33, 34, 0.3)',
                  '&:hover': {
                    bgcolor: '#8a1e1f',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 20px rgba(159, 33, 34, 0.4)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Learn More
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default About;
